import { calculateDrywallWeight, numberWithCommas, getRecommendedDumpsterTitleByTons } from '../../components/calculator/calculations'

export default function drywallCalculator (calculatorForm, calculatorEstimatedWeightPanel, calculatorResultsPanel, calculatorRecommendedDumpsterTitle, calculatorRecommendedDumpsterImage, toggleResults) {
  const typeInput = calculatorForm.querySelector('[data-js-drywall-calculator-type-input]')
  const lengthInput = calculatorForm.querySelector('[data-js-drywall-calculator-length-input]')
  const widthInput = calculatorForm.querySelector('[data-js-drywall-calculator-width-input]')
  const countInput = calculatorForm.querySelector('[data-js-drywall-calculator-count-input]')

  calculatorForm.addEventListener('submit', calculateDrywallResults)

  function calculateDrywallResults (event) {
    event.preventDefault()
    const { pounds, tons } = calculateDrywallWeight(typeInput.value, lengthInput.value, widthInput.value, countInput.value)
    toggleResults()
    calculatorEstimatedWeightPanel.children[0].innerText = `${numberWithCommas(pounds)} lbs or ${tons} ton(s)`
    calculatorRecommendedDumpsterTitle.innerText = getRecommendedDumpsterTitleByTons(tons)
  }
}
